import { getMockFileUrl, isMockActive } from 'src/utils/env'
import { PlatformHttpClient } from 'src/network/PlatformHttpClient'
import { MockHttpClient, MockVisorClient, MockOrderingClient } from 'src/mocks'
import { extname } from 'src/utils/extname'
import { TranscriptHttpClient } from 'src/network/TranscriptHttpClient'
import { VisorHttpClient } from 'src/network/VisorHttpClient'
import { OrderingHttpClient } from 'src/network/OrderingHttpClient'

const mock = getMockFileUrl()

const shouldUseMocks = isMockActive() && extname(mock) === 'json'

export const platformHttpClient = shouldUseMocks ? new MockHttpClient() : new PlatformHttpClient()
export const transcriptHttpClient = new TranscriptHttpClient()
export const visorHttpClient = shouldUseMocks ? new MockVisorClient() : new VisorHttpClient()
export const orderingHttpClient = shouldUseMocks ? new MockOrderingClient() : new OrderingHttpClient()
